// extracted by mini-css-extract-plugin
module.exports = {"menu":"MenuBar_menu__3QEgZ","separator":"MenuBar_separator__117Bd"};